import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/index";
import Loading from "../HOC/loading";

export default function requireAuth(WrappedComponent) {

    class AdminAuth extends Component {

        componentDidMount = () => {
            this.props.actions.isadmin()
        }

        render() {
            if (this.props.admin === true || this.props.isspecialist === true ) {
                return <WrappedComponent {...this.props} />
            }
            if (this.props.admin === false) {
                return <Redirect to="/unauthorized" />
            }
            return <Loading />
        }
    }

    function mapStateToProps(state) {
        return {
            loading: state.isadminreducer.loading,
            admin: state.isadminreducer.isadmin,
            isspecialist: state.isadminreducer.isspecialist
        }
    }
    function mapDispatchToProps(dispatch) {
        return {
            actions: bindActionCreators(actions, dispatch)
        }
    }
    return connect(mapStateToProps, mapDispatchToProps)(AdminAuth);
}



// WEBPACK FOOTER //
// ./src/components/HOC/AdminAuth.js